import type { Page } from '../../types';
import { getColumns, getKeys, getRows } from '../../../components/form/CoreVacConsolidatedInput';

const vacancyHolderExperience: Page[] = [
  {
    pageType: 'question',
    title: 'Vacancy Holder Experience',
    name: 'nps-vacholder',
    questions: [
      {
        questionType: 'CoreVacConsolidatedInput',
        title: 'Net Promotor Score',
        name: 'nps-vacholder',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments and observations',
        name: 'nps-vacholder-comments',
        hint: 'Please outline any factors that may explain quarter-on-quarter change or influence these reported figures.',
        rules: {
          required: false,
        },
      },
    ],
  },
];

export default vacancyHolderExperience;
